import React from "react";
import "./style.scss";
import HTMLReactParser from "html-react-parser";
import statup1 from "./img/objective-startup-1.png";
import statup2 from "./img/objective-startup-2.png";
import statup3 from "./img/objective-startup-3.png";
import { useTranslation } from 'react-i18next';
export default function NationalMentorShip(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  
  keyData[1]=`<p>${t('formalised_and_structured_platform')}</p>`
  return (
    <div className="nationaal-obj">
      <section
        id="objectives"
      >
        <div className="w-100 pt-50 pb-50 position-relative">
          <div className="container">
            <div className="row">
              <div className="sec-title text-center w-100 position-relative">
                <h2 className="mb-0 homepageFirstHeader">
                {t('Objectives_of_MAARG_Portal_by_Startup')}
                {/* Objectives of MAARG Portal by Startup India  */}
                </h2>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row pt-50">
              <div className="col-md-4 col-sm-6 col-lg-4 wow slideInLeft">
                <div className="contribute-box">
                  <img src={statup1} />
                  <br />
                  <p>
                    <a className="contribute" title="">
                      1
                    </a>
                  </p>
                  <p className="contribute-text homepageFirstDescription">{HTMLReactParser(keyData[0])}</p>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-lg-4 wow fadeInDown">
                <div className="contribute-box">
                  <img src={statup2} /> <br />
                  <p>
                    <a className="contribute" title="">
                      2
                    </a>
                  </p>
                  <p className="contribute-text homepageFirstDescription">{HTMLReactParser(keyData[1])}</p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-lg-4 wow slideInRight">
                <div className="contribute-box">
                  <img src={statup3} /> <br />
                  <p>
                    <a className="contribute" title="">
                      3
                    </a>
                  </p>
                  <p className="contribute-text homepageFirstDescription">{HTMLReactParser(keyData[2])}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
